export const merchantsSampleFile = 'merchant-sample.csv';
export const notesSampleFile = 'notes-sample.csv';
export const reservesSampleFile = 'reserves-sample.csv';
